<template lang="html">
  <div class="modal-wrapper">
    <div class="modal-close">
      <img
        @click="closeModal()"
        src="@/assets/icons/close.png"
        alt="close-modal-img"
      />
    </div>
    <div class="modal-title">
      {{ modalData.title }}
      <questionmark :id="55" :toast="true" />
    </div>
    <div class="content">
      <!-- product name: -->
      <div class="info">
        <span class="info-key"> {{ $t("profile.purchase.subject") }} : </span>
        <span class="info-value">
          <input maxlength="40" type="text" v-model="name" />
        </span>
      </div>
      <!-- product expiry date -->
      <div class="info">
        <span class="info-key"> {{ $t("profile.purchase.expiry") }} : </span>
        <span class="info-value">
          <datetime
            v-model="date"
            :max-datetime="sixMonthsDate"
            :min-datetime="tomorrowDate"
            type="datetime"
          />
        </span>
      </div>
      <!-- product quantity -->
      <div class="info">
        <span class="info-key"> {{ $t("profile.purchase.quantity") }} : </span>
        <span class="info-value">
          <input
            v-model="quantity"
            onkeydown="if(event.key==='.'){event.preventDefault();}"
            @change="checkQuantity"
            :disabled="prices.length > 0"
            type="number"
            @keydown="keyUpQuantity"
            max="99999999"
            :step="1"
            :min="4"
          />
        </span>
      </div>
      <!-- jedinicna cena -->
      <div class="info">
        <span class="info-key">
          {{ $t("profile.purchase.startingPrice") }} :
        </span>
        <span class="info-value">
          <currency-input
            locale="en"
            :currency="null"
            :disabled="prices.length > 0"
            :value="basePrice"
            :precision="0"
            @change="basePrice = parseNumber($event)"
            maxlength="9"
          />
        </span>
      </div>
      <!-- product discounts: -->
      <div
        v-if="prices.length < 5 && parseInt(quantityMin) < quantity"
        class="info"
      >
        <span class="info-key"
          >{{ $t("profile.purchase.adddiscount") }} :
        </span>
        <span class="info-value prices">
          <span>{{ $t("profile.purchase.of") }}:</span>
          <span>{{ quantityMin }}</span>
          <span>{{ $t("profile.purchase.to") }}:</span>
          <input
            type="number"
            :min="parseInt(quantityMin) + 1"
            v-model="quantityMax"
            :max="quantity"
            @change="
              fixNumber($event.target.min, $event.target.max, 'quantityMax')
            "
            @keydown="rangefunction($event)"
          />
          <span>{{ $t("profile.purchase.price") }}:</span>
          <input
            v-if="prices.length > 0"
            type="number"
            :min="1"
            v-model="price"
            @change="fixNumber($event.target.min, $event.target.max, 'price')"
            :max="getMaxPrice"
            :step="1"
          />
          <span v-else>
            {{ basePrice }}
          </span>
          <div @click="addDiscount" class="btn dark-blue">
            {{ $t("profile.purchase.add") }}
          </div>
        </span>
      </div>

      <div class="info">
        <span class="info-key"> {{ $t("profile.purchase.discounts") }} : </span>
        <span
          v-for="(price, index) in prices"
          :key="price.id"
          style="flex-grow: 0;"
          class="info-value"
        >
          {{ price.min }} - {{ price.max }} : {{ price.price }}&nbsp;{{
            currency
          }}{{ prices[index + 1] ? "," : "" }}&nbsp;&nbsp;
        </span>
        <img
          style="cursor: pointer;"
          v-if="prices.length > 0"
          @click="removeDiscount"
          src="@/assets/icons/trash.png"
          alt="trash icon"
        />
      </div>
      <div class="info back">
        <span class="info-key">*{{ $t("profile.purchase.minDiscount") }}</span>
      </div>
      <div class="info back">
        <span class="info-key">*{{ $t("main.inputsRequired") }}</span>
      </div>
    </div>
    <div class="btn-wrapper">
      <div @click="ok()" class="btn dark-blue">
        {{ $t("main.renew") }}
      </div>
      <div @click="closeModal()" class="btn dark-blue outlined">
        {{ $t("main.cancel") }}
      </div>
    </div>
  </div>
</template>

<script>
import Questionmark from "@/components/questionmark.vue";
import { api } from "@/api";
import eventBus from "@/shared/eventBus.js";
export default {
  name: "confirmModal",
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  components: {
    Questionmark
  },
  data() {
    return {
      date: null,
      quantity: null,
      quantityMin: 1,
      quantityMax: null,
      prices: [],
      name: null,
      basePrice: 0,
      currency: null,
      price: null
    };
  },
  mounted() {
    console.log(this.modalData);
    this.getProductInfo();
  },
  methods: {
    keyUpQuantity(e) {
      if (this.quantity >= 99999999) {
        e.preventDefault();
      }
    },
    ok() {
      if (!this.name) {
        this.$toast.error(this.$t("renew.nameMissing"), {
          duration: 8000
        });
        return;
      }
      if (this.name.length < 4 || this.name.length > 40) {
        this.$toast.error(this.$t("renew.badName"), {
          duration: 8000
        });
        return;
      }
      if (!this.date || this.date === "") {
        this.$toast.error(this.$t("renew.dateMissing"), {
          duration: 8000
        });
        return;
      }
      if (!this.quantity) {
        this.$toast.error(this.$t("renew.quantityMissing"), {
          duration: 8000
        });
        return;
      }
      if (!this.basePrice) {
        this.$toast.error(this.$t("renew.basePriceMissing"), {
          duration: 8000
        });
        return;
      }
      if (this.prices.length < 2 || this.prices.length > 5) {
        this.$toast.error(this.$t("renew.pricesLengthError"), {
          duration: 8000
        });
        return;
      }
      if (
        parseInt(this.prices[this.prices.length - 1].max) !==
        parseInt(this.quantity)
      ) {
        this.$toast.error(this.$t("renew.useAllQuantityError"), {
          duration: 8000
        });
        return;
      }
      let params = {
        id: this.modalData.id,
        pro_expiry: this.date,
        prices: this.prices,
        pro_base_price: this.basePrice,
        pro_name: this.name
      };
      eventBus.$emit("showLoader", true);
      api
        .renew(params)
        .then(res => {
          this.$toast.success(this.$t("renew.success"), {
            duration: 8000
          });
          this.closeModal();
        })
        .catch(() => {
          this.$toast.error(this.$t("renew.error"), {
            duration: 8000
          });
        })
        .finally(() => {
          eventBus.$emit("showLoader", false);
        });
    },
    getProductInfo() {
      const params = {
        id: this.modalData.id
      };
      api
        .getProductInfo(params)
        .then(res => {
          console.log(res.data.data);
          this.currency = res.data.data.cur_id;
          this.name = res.data.data.pro_name;
          this.quantity = res.data.data.quantity;
          this.basePrice = res.data.data.pro_base_price;
          this.prices = res.data.data.prices;
          this.quantityMin =
            res.data.data.prices[res.data.data.prices.length - 1].max + 1;
        })
        .catch(e => {
          console.log(e);
        });
    },
    fixNumber(min, max, value) {
      console.log(
        this.parseNumber(this[value]),
        this.parseNumber(max),
        this.parseNumber(min)
      );
      if (this.parseNumber(this[value]) > this.parseNumber(max)) {
        this[value] = this.parseNumber(max);
      } else if (this.parseNumber(this[value]) < this.parseNumber(min)) {
        this[value] = this.parseNumber(min);
      }
    },
    removeDiscount() {
      this.prices.pop();
      if (this.prices[this.prices.length - 1]) {
        this.quantityMin =
          parseInt(this.prices[this.prices.length - 1].max) + 1;
        this.quantityMax =
          parseInt(this.prices[this.prices.length - 1].max) + 2;
      } else {
        this.quantityMin = 1;
        this.quantityMax = 2;
      }
    },
    addDiscount() {
      if (this.prices.length === 0) {
        this.price = this.basePrice;
      }
      let quantityMin = parseInt(this.quantityMin);
      let quantityMax = parseInt(this.quantityMax);
      let price = this.parseNumber(this.price);
      if (!quantityMin || quantityMin < 1) {
        console.log("quantityMin los");
        return;
      }
      if (!quantityMax || quantityMax <= quantityMin) {
        console.log("quantityMax los");
        return;
      }
      if (quantityMax > this.quantity) {
        this.$toast.error(this.$t("main.quantityMaxError"), {
          duration: 8000
        });
        return;
      }
      if (!price) {
        console.log("price los");
        return;
      }
      let obj = {
        min: quantityMin,
        max: quantityMax,
        price: price
      };
      this.prices.push(obj);
      this.quantityMin = parseInt(this.quantityMax) + 1;
      this.quantityMax = parseInt(this.quantityMax) + 2;
      this.price = null;
    },
    parseNumber(num) {
      return parseFloat(((num * 100) / 100).toFixed(2));
    },
    closeModal() {
      if (this.modalData.cancel) {
        this.modalData.cancel();
      }
      eventBus.$emit("closeModal");
    },
    checkQuantity() {
      console.log("asd", this.quantity);
      if (parseInt(this.quantity) < 4) {
        this.quantity = 4;
      }
    }
  },
  computed: {
    tomorrowDate() {
      let today = new Date();
      let tomorrow = new Date(today.setDate(today.getDate() + 1));
      return tomorrow.toISOString();
    },
    sixMonthsDate() {
      let today = new Date();
      let endDate = new Date(today.setMonth(today.getMonth() + 6));
      return endDate.toISOString();
    },
    getMaxPrice() {
      if (this.prices.length > 0) {
        return this.parseNumber(this.prices[this.prices.length - 1].price) - 1;
      } else {
        return this.parseNumber(this.basePrice);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
.modal-wrapper {
  width: 500px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
  @import "@/assets/scss/cardStyles.scss";

  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .inputs {
    .single-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 10px;
    }
  }
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .btn {
      margin-left: 15px;
      // width: 130px;
    }
  }
  .info {
    margin-bottom: 25px;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: left;
    flex-wrap: wrap;

    .info-key {
      font-weight: normal;
      font-size: 13px;
      line-height: 21px;
      color: #787878;
      margin-right: 15px;
      // white-space: nowrap;
      min-width: 150px;
    }
    .info-value {
      font-weight: 800;
      font-size: 13px;
      line-height: 21px;
      letter-spacing: 0.02em;
      color: $text-color;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      flex-grow: 1;
      justify-content: flex-start;

      textarea {
        width: 100%;
        border: 1px solid #dfdfdf;
        outline: none;
        resize: none;
        margin-top: 5px;
      }
      input[type="text"] {
        width: 100%;
      }
      .filter-wrapper {
        margin-right: 10px;
      }
      .declaration-wrapper {
        margin-right: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        img {
          margin-left: 5px;
        }
      }
      input {
        height: 40px;
        border: 1px solid #e8e8e8;
        padding-left: 5px;
      }
    }
    .info-value.wide {
      width: 100%;
    }
    .info-value.prices {
      display: flex;
      flex-direction: row;
      align-items: center;
      * {
        margin-right: 10px;
      }
      input {
        width: 60px;
      }
      .btn {
        width: 100px;
      }
    }
  }
}
</style>
<style lang="scss" media="screen">
.vdatetime-input {
  height: 40px;
  border: 1px solid #e8e8e8;
  padding-left: 5px;
}
.vdatetime-popup__header {
  background-color: $blue-600;
}
.vdatetime-popup__actions div {
  color: $blue-600;
}
.vdatetime-calendar__month__day--selected > span > span,
.vdatetime-calendar__month__day--selected:hover > span > span {
  color: #fff;
  background: $blue-600;
}
.vdatetime-time-picker__item--selected {
  color: $blue-600;
}
</style>
